import api from './api';

/**
 * Create a share link
 */
export const createShareLink = async ({
  resourceType,
  resourceId,
  title,
  message,
  permissions,
  expiresInDays
}) => {
  const response = await api.post('/share/create', {
    resourceType,
    resourceId,
    title,
    message,
    permissions,
    expiresInDays
  });
  return response.data;
};

/**
 * Get user's share links
 */
export const getShareLinks = async () => {
  const response = await api.get('/share');
  return response.data;
};

/**
 * Update a share link
 */
export const updateShareLink = async (id, updates) => {
  const response = await api.patch(`/share/${id}`, updates);
  return response.data;
};

/**
 * Delete a share link
 */
export const deleteShareLink = async (id) => {
  const response = await api.delete(`/share/${id}`);
  return response.data;
};

/**
 * View shared resume (public)
 */
export const viewSharedResume = async (token) => {
  const response = await api.get(`/share/view/${token}`);
  return response.data;
};

/**
 * Submit feedback (public)
 */
export const submitFeedback = async (token, feedback) => {
  const response = await api.post(`/share/feedback/${token}`, feedback);
  return response.data;
};

/**
 * Get user's feedback
 */
export const getFeedback = async ({ unreadOnly, limit, offset } = {}) => {
  const params = new URLSearchParams();
  if (unreadOnly) params.append('unreadOnly', 'true');
  if (limit) params.append('limit', limit);
  if (offset) params.append('offset', offset);

  const response = await api.get(`/share/feedback?${params.toString()}`);
  return response.data;
};

/**
 * Mark feedback as read
 */
export const markFeedbackRead = async (id) => {
  const response = await api.patch(`/share/feedback/${id}/read`);
  return response.data;
};

/**
 * Mark feedback as helpful
 */
export const markFeedbackHelpful = async (id, isHelpful) => {
  const response = await api.patch(`/share/feedback/${id}/helpful`, { isHelpful });
  return response.data;
};

/**
 * Get feedback stats
 */
export const getFeedbackStats = async () => {
  const response = await api.get('/share/feedback/stats');
  return response.data;
};

export default {
  createShareLink,
  getShareLinks,
  updateShareLink,
  deleteShareLink,
  viewSharedResume,
  submitFeedback,
  getFeedback,
  markFeedbackRead,
  markFeedbackHelpful,
  getFeedbackStats
};
